import DefaultList from "@/components/DefaultList";
import DictionaryCreator from "@/components/dictionaries/DictionaryCreator";
import DictionaryEditor from "@/components/dictionaries/DictionaryEditor";
import { PATH_DICTS_CITIZENSHIPS } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { defaultDictionaryTableFeatures } from "@/containers/dictionaries/defaultDictionaryTableFeatures";
import { Module } from "@/constants";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import { readCitizenship, writeCitizenship } from "@/schemas/citizenship";
import { CitizenshipService } from "@/services/citizenship";
import { ReadCitizenship, WriteCitizenship } from "@/types/citizenship";
import { Flag } from "lucide-react";

const id = Module.Citizenships;
const path = PATH_DICTS_CITIZENSHIPS;
const ns = "citizenships";

const config: DictionaryConfig<ReadCitizenship, WriteCitizenship> = {
  id,
  ns,
  service: CitizenshipService,
  path,
  labels: createDictionaryLabels(ns),
  getLabels: getDictionaryLabels,
  schema: writeCitizenship,
  defaultValues: {
    name: "",
    sort_order: 0,
  },
  Icon: Flag,
  List: () => (
    <DefaultList<ReadCitizenship>
      schema={readCitizenship}
      name={ns}
      fetchList={CitizenshipService.getList}
      pathBuilder={(row) => `${path}/${row.id}`}
      tableFeatures={{
        ...defaultDictionaryTableFeatures,
        exportSettings: { moduleName: Module.Citizenships },
      }}
    />
  ),
  Creator: DictionaryCreator,
  Editor: DictionaryEditor,
};

export default config;
